<mat-progress-bar [mode]="syncing || isLoading ? 'indeterminate' : 'determinate'" color="primary"></mat-progress-bar>

<div *ngIf="!isLoading && (!plan || !plan.document)">
  <h3>Plan Not Found</h3>
  <a href="#" (click)="back($event)">Return to Planning</a>
</div>

<div *ngIf="plan && plan.document">
  <div fxLayout="column" fxLayoutGap="16px">
    <document-plan-title-bar
      [title]="plan.document.name"
      [startDate]="plan.document.start_date"
      [numWeeks]="plan.document.num_weeks"
      [isOnline]="isOnline"
      [isOwner]="isOwner"
      (edited)="edit()"
      (shared)="share()"
      (viewSwitched)="switchView()"
      (monthPrinted)="printMonth()"
      (weekPrinted)="printWeek()"
      (refreshed)="refresh()"
      (published)="publish()"
      (copied)="copyPlan()"
    ></document-plan-title-bar>
    <div fxLayout="row" fxLayoutGap="16px">
      <document-calendar id="calendar"
        fxFlex
        [monthView]="monthView"
        [startDate]="plan.document.start_date"
        [numWeeks]="plan.document.num_weeks"
        [workouts]="plan.document.workouts"
        [phases]="plan.document.phases"
        [canEdit]="isOwner"
        [workoutTypes]="workoutTypes"
        [restrictLabels]="restrictLabels"
        [phaseTypes]="phaseTypes"
        (standardWorkoutAdded)="addStandardWorkout($event)"
        (customWorkoutAdded)="addCustomWorkout($event)"
        (restrictedWorkoutAdded)="addRestrictedWorkout($event)"
        (workoutAddedFromLibrary)="addWorkoutFromLibrary($event)"
        (phasesUpdated)="addPhase($event)"
        (workoutSelected)="selectWorkout($event)"
        (workoutCopied)="addWorkoutsFromSelectedDays($event)"
        (programmingChartOpened)="openProgrammingChart()"
      ></document-calendar>
      <document-plan-summary
        fxFlex="42"
        [phases]="plan.document.phases"
        [phaseTypes]="phaseTypes"
        [startDate]="plan.document.start_date"
        [numWeeks]="plan.document.num_weeks"
        [userLibrary]="userLibrary"
        (templateItemRemoved)="removeLibraryItem($event)"
      ></document-plan-summary>
    </div>
    <div fxLayout="column" *ngIf="!monthView && selectedDay">
      <div *ngIf="copying" class="copy-overlay"></div>
      <document-plan-day-actions
        [day]="selectedDay"
        [canEdit]="isOwner"
        [isOnline]="isOnline"
        [isSynced]="isSynced"
        (cleared)="clearDay($event)"
        (addedToLibrary)="addWorkoutToLibrary($event)"
        (completed)="completeDay($event, true)"
        (unfinished)="completeDay($event, false)"
        (downloaded)="downloadDay($event)"
        (workoutSelected)="selectWorkout($event)"
        (programmingChartOpened)="openProgrammingChart()"
        (standardWorkoutAdded)="addStandardWorkout($event)"
        (customWorkoutAdded)="addCustomWorkout($event)"
        (restrictedWorkoutAdded)="addRestrictedWorkout($event)"
        (workoutAddedFromLibrary)="addWorkoutFromLibrary($event.day)"
      ></document-plan-day-actions>
      <document-plan-day-summary
        *ngIf="!dayView"
        [workout]="selectedDay.workout"
        [exercises]="exercises"
        [restrictLabel]="selectedDay.restrictLabel"
        (addedToLibrary)="addTierToLibrary($event)"
      ></document-plan-day-summary>
      <document-day-planning
        *ngIf="dayView"
        [canEdit]="isOwner"
        [workout]="selectedDay.workout"
        [workoutType]="selectedDay.workoutType"
        [exercises]="exercises"
        [exerciseCategories]="exerciseCategories"
        [planMetadata]="plan.document['metadata']"
        (tierUpdated)="editTier($event)"
        (tiersUpdated)="editTiers($event)"
        (workoutNameUpdated)="editWorkoutName($event)"
        (workoutCompletionTimeUpdated)="editWorkoutCompletionTime($event)"
        (workoutEstimatedRPEUpdated)="editWorkoutEstimatedRPE($event)"
        (viewSwitched)="switchDayView($event)"
        (addedTierToLibrary)="addTierToLibrary($event)"
        (addedTierFromLibrary)="addTierFromLibrary($event)"
      ></document-day-planning>
    </div>
  </div>
</div>
